import { Inject, Injectable } from '@angular/core';

import { IApiConfigService, API_CONFIG_SERVICE } from './api-config.service.interface';

@Injectable()
export class ApiConfigService implements IApiConfigService {

  constructor(@Inject(API_CONFIG_SERVICE) private config: IApiConfigService) { }

  loginUrl(): string {
    return this.config.loginUrl();
  }

  accountApiUrl(): string {
    return this.config.accountApiUrl();
  }

  logoutApiUrl(): string {
    return this.config.logoutApiUrl();
  }

  refreshTokenUrl(): string {
    return this.config.refreshTokenUrl();
  }

  forgotPasswordUrl(): string {
    return this.config.forgotPasswordUrl();
  }

  changePasswordUrl(): string {
    return this.config.changePasswordUrl();
  }
}
